<template>
  <a-row type="flex" justify="space-between">
    <a-col :span="24">
      <a-row type="flex" justify="space-between" align="bottom" style="margin-bottom: 30px">
        <a-col :span="14" class="titulo">Api Keys</a-col>
        <a-col><a-button type="primary" size="large" @click="create">Generar nueva key</a-button></a-col>
      </a-row>
    </a-col>
    <a-col :span="24"
      style=" word-break: break-all; background-color: white; padding: 20px 10px 5px; border-radius: 5px;"
      class="shadow">
      <a-row>
        <a-table :columns="columnsListTable" :dataSource="apikeys" rowKey="id" :pagination="pagination">
          <span slot="action" slot-scope="text, record">
            <a-button type="primary" shape="circle" icon="delete" @click="remove(record.id)"></a-button>
          </span>
        </a-table>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import utils from '../service/service.js'
export default {
  name: "Apikey",
  // props: {},
  mixins: [utils],
  data() {
    return {
      isAdmin: "0",
      apikeys: [],
      columnsListTable: [
        {
          title: "Key",
          dataIndex: "key",
        },
        {
          title: "Creada",
          dataIndex: "created_at",
        },
        {
          title: "Eliminar",
          scopedSlots: { customRender: "action" },
          width: "120px",
        },
      ],
      pagination: { pageSize: 8 },
    };
  },
  mounted: function () {
    this.load();
  },
  methods: {
    load() {
      this.sendRequest({
        method: 'GET',
        url:'apikeys/list'
      }).then(({data}) => {
        this.apikeys = data
      })
    },
     create() {
       this.sendRequest({
         method:'POST',
         url: 'apikeys/generate'
       }).then(() => {
         this.load()
         this.$message.success("Api key creada")
       })
     },
    remove(id) {
      const $this = this;
      this.$confirm({
        title: '¿ Estas seguro que queres eliminar este api key ?',
        content: 'Esta opción no puede revertirse',
        okText: 'Si',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          $this.sendRequest({
            method:'POST',
            url: 'apikeys/delete/' + id
          }).then(() => {
            $this.load()
            $this.$message.success("Api key eliminada")
          })
        },
        onCancel() {
        },
      });

    }
  },
  computed: {

  }
};
</script>

<style scoped>
.titulo {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  color: #2c3e50;
}

.shadow {
  box-shadow: 2px 1px 5px -4px;
}

.shadowInputs {
  box-shadow: 1px 1px 5px -5px;
}
</style>
